export const urls = {
  addCourseDetails: 'course/add',
  updateCourseDetails: 'course/edit',
  courseList: 'course/list',
  updateCategory: 'category/edit',
  addCategory: 'category/add',
  fileUpload: 'common/fileUpload',
  categoryList: 'category/list',
  subjectList: 'subject/list',
  registrationList: 'registrationList',
  locationList: 'locationList',
  gradeList: 'gradeList',
  addBlogger: 'addBlogger',
  updateBlogger: 'updateBlogger',
  bloggerList: 'bloggerList',
  viewCount: 'viewCount',
  deleteBlogger: 'deleteBlogger',
  addCareer: 'addCareer',
  updateCareer: 'updateCareer',
  careerList: 'careerList',
  jobDetails: 'jobDetails',
  addCourseSchedule: 'classes/add',
  updateCourseSchedule: 'classes/edit',
  userList: 'userList',
  courseSchedule: 'courseSchedule',
  courseSeo: 'course/seoList',
  addCourseSeo: 'course/addSeo',
  updateCourseSeo: 'course/updateSeo',
  availabilityTimeCheck: 'common/availabilityTimeCheck',
  addEvent: 'addEvent',
  updateEvent: 'updateEvent',
  eventList: 'eventList',
  countryList: 'countryList',
  stateList: 'stateList',
  teacherList: 'classes/teacherList',
  addTeacher: 'addTeacher',
  updateTeacher: 'updateTeacher',
  adminList: 'adminList',
  addAdmin: 'addAdmin',
  updateAdmin: 'updateAdmin',
  blogSeo: 'blogSeo',
  addBlogSeo: 'addBlogSeo',
  updateBlogSeo: 'updateBlogSeo',
  addContentCreator: 'addContentCreator',
  editContentCreator: 'editContentCreator',
  contentCreatorList: 'contentCreatorList',
  blogCategoryList: 'blogCategoryList',
  blogCategoryAdd: 'blogCategoryAdd',
  blogCategoryEdit: 'blogCategoryEdit',
  settingList: 'settingList',
  settingEdit: 'settingEdit',
  entityList: 'entityList',
  entityAdd: 'entityAdd',
  entityEdit: 'entityEdit',
  entityBranchList: 'entityBranchList',
  addEntityBranch: 'addEntityBranch',
  editEntityBranch: 'editEntityBranch',
  faqList: 'course/faqList',
  addFaq: 'course/addFaq',
  updateFaq: 'course/updateFaq',
  dateFormat: 'dateFormat',
  timeZoneList: 'timeZoneList',
  coreSettingList: 'getCoreSettings',
  paymentType: 'paymentTypes',
  couponList: 'couponList',
  couponAdd: 'couponAdd',
  couponEdit: 'couponEdit',
  subjectAdd: 'subjectAdd',
  subjectEdit: 'subjectEdit',
  downloadExcel: 'downloadExcel',
  bulkUpload: 'bulkUpload',
  getGradeList: 'grade/list',
  contentCategoryAdd: 'sitecontent/categoryAdd',
  contentCategoryEdit: 'sitecontent/categoryEdit',
  contentCategoryList: 'sitecontent/categoryList',
  contentSeoAdd: 'sitecontent/addSeo',
  contentSeoEdit: 'sitecontent/editSeo',
  contentSeoList: 'sitecontent/seoList',
  contentAdd: 'sitecontent/addContent',
  contentEdit: 'sitecontent/editContent',
  contentList: 'sitecontent/listContent',
  validateUser: 'user/validateUser',
  orderList: 'course/orderList',
  makeUpClass: 'student/makeUpClass',
  addOverallFeedback: 'teacher/addOverallFeedback',
  updateOverallFeedback: 'teacher/updateOverallFeedback',
  getOverallFeedback: 'teacher/getOverallFeedback',
  classesWhiteboardList: 'classes/whiteboardList',
  studentloginResponse: 'student/loginResponse',
  teacherloginResponse: 'teacher/loginResponse',
  sendStudentSms: 'student/sendStudentSms',
  recordingMeetingList: 'student/recordingMeetingList',
  recordingDetail: 'student/recordingDetail',
  curriculumList: 'student/curriculumList',
  feedback: 'feedback/list',
  report: 'report/gradeReport',
  getVersion: 'common/getVersion',
  updateQuestionSection: 'content/updateQuestionSection'
};

